<div class="profile-page">
  <!-- ====================================================== -->
  <!-- HEADER -->
  <!-- ====================================================== -->

  <div class="profile-header">
    <div class="profile-header-info">
      <div class="profile-header-icon">
        <i class="fa-solid fa-user"></i>
      </div>

      <div>
        <h4 class="profile-title">Mi perfil</h4>

        <p class="profile-description">
          Administra tus datos, certificados y configuración de firma.
        </p>
      </div>
    </div>

    <!-- AYUDA -->

    <button type="button" class="help-btn" (click)="onHelp(true)" aria-label="Ayuda" title="Ver ayuda">
      <i class="fa-solid fa-circle-question"></i>
    </button>
  </div>

  <!-- ====================================================== -->
  <!-- CONTENIDO -->
  <!-- ====================================================== -->

  <div class="profile-content">
    <ngb-accordion [closeOthers]="true" [activeIds]="activePanelId" class="profile-accordion">
      <!-- ================================================== -->
      <!-- MIS DATOS -->
      <!-- ================================================== -->

      <ngb-panel id="datos">
        <ng-template ngbPanelTitle>
          <div class="accordion-title" data-tour="perfil-datos-title">
            <div class="accordion-icon">
              <i class="fa-solid fa-user"></i>
            </div>

            <div class="accordion-title-info">
              <span class="accordion-title-text"> Mis datos </span>

              <span class="accordion-title-description">
                Información asociada a tu cuenta.
              </span>
            </div>
          </div>
        </ng-template>

        <ng-template ngbPanelContent>
          <div class="section-content">
            <!-- LDAP INFO -->

            <div class="info-alert" *ngIf="isLdap">
              <div class="info-alert-icon">
                <i class="fa-solid fa-circle-info"></i>
              </div>

              <div>
                <strong>Usuario institucional</strong>

                <span>
                  Los datos están disponibles únicamente en modo lectura.
                </span>
              </div>
            </div>

            <!-- FORMULARIO -->

            <form [formGroup]="formPerfil" class="profile-form needs-validation">
              <div class="row g-3">
                <!-- USUARIO -->

                <div class="col-12 col-md-6">
                  <div class="field-group">
                    <label for="username" class="form-label"> Usuario </label>

                    <div class="input-modern">
                      <i class="fa-solid fa-user"></i>

                      <input type="text" id="username" formControlName="username" class="form-control"
                        placeholder="Usuario" />
                    </div>
                  </div>
                </div>

                <!-- CORREO -->

                <div class="col-12 col-md-6">
                  <div class="field-group">
                    <label for="email" class="form-label">
                      Correo electrónico
                    </label>

                    <div class="input-modern">
                      <i class="fa-solid fa-envelope"></i>

                      <input type="text" id="email" formControlName="email" class="form-control"
                        placeholder="Correo electrónico" [disabled]="true" />
                    </div>
                  </div>
                </div>

                <!-- NOMBRES -->

                <div class="col-12 col-md-6">
                  <div class="field-group">
                    <label for="firstName" class="form-label"> Nombres </label>

                    <div class="input-modern">
                      <i class="fa-solid fa-address-card"></i>

                      <input type="text" id="firstName" formControlName="firstName" class="form-control"
                        placeholder="Nombres" />
                    </div>
                  </div>
                </div>

                <!-- APELLIDOS -->

                <div class="col-12 col-md-6">
                  <div class="field-group">
                    <label for="lastName" class="form-label"> Apellidos </label>

                    <div class="input-modern">
                      <i class="fa-solid fa-address-card"></i>

                      <input type="text" id="lastName" formControlName="lastName" class="form-control"
                        placeholder="Apellidos" />
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <!-- ================================================= -->
                  <!-- VISIBILIDAD -->
                  <!-- ================================================= -->

                  <div class="visibility-section" [class.public-mode]="formPerfil.get('accesoGuiado')?.value">


                    <div class="visibility-info">


                      <!-- ICONO -->

                      <div class="visibility-icon">

                        <i class="fa-solid" [ngClass]="
                                formPerfil.get('accesoGuiado')?.value
                                    ? 'fa-globe'
                                    : 'fa-lock'
                            ">
                        </i>

                      </div>


                      <!-- TEXTO -->

                      <div>

                        <div class="visibility-title">

                          Visibilidad

                          <span class="visibility-badge" [class.badge-public]="formPerfil.get('accesoGuiado')?.value"
                            [class.badge-private]="!formSignatureSize.get('accesoGuiado')?.value">

                            {{
                            formPerfil.get('accesoGuiado')?.value
                            ? 'Activa'
                            : 'Inactiva'
                            }}

                          </span>

                        </div>


                        <small class="visibility-description">

                          {{
                          formPerfil.get('accesoGuiado')?.value
                          ? 'La ayuda guiada esta activa en todo el sistema.'
                          : 'La ayuda guiada esta activada en todo el sistema.'
                          }}

                        </small>

                      </div>

                    </div>


                    <!-- SWITCH -->

                    <label class="modern-switch">

                      <input type="checkbox" id="publica" formControlName="accesoGuiado"
                        (change)="onAccesoGuiadoChange()">

                      <span class="slider"></span>

                    </label>

                  </div>
                </div>
              </div>

              <!-- ACCIONES -->

              <div class="section-actions" *ngIf="!isLdap">
                <button type="button" class="btn btn-primary btn-modern" data-tour="perfil-datos-save" (click)="save()">
                  <i class="fa-solid fa-floppy-disk"></i>

                  <span> Guardar cambios </span>
                </button>
              </div>
            </form>
          </div>
        </ng-template>
      </ngb-panel>

      <!-- ================================================== -->
      <!-- CERTIFICADOS -->
      <!-- ================================================== -->

      <ngb-panel id="certificados" (shown)="onCertificadosOpened()">
        <ng-template ngbPanelTitle>
          <div class="accordion-title" data-tour="perfil-certificados-title">
            <div class="accordion-icon">
              <i class="fa-solid fa-file-signature"></i>
            </div>

            <div class="accordion-title-info">
              <span class="accordion-title-text"> Mis certificados </span>

              <span class="accordion-title-description">
                Administra los certificados asociados a tu usuario.
              </span>
            </div>
          </div>
        </ng-template>

        <ng-template ngbPanelContent>
          <div class="section-content">
            <!-- TOOLBAR -->

            <div class="certificate-toolbar">
              <div>
                <h6 class="section-subtitle">Certificados asociados</h6>

                <p class="section-subdescription">
                  Consulta, administra o agrega certificados.
                </p>
              </div>

              <button type="button" class="btn btn-primary btn-modern" data-tour="cert-add-btn"
                (click)="openModal(content)">
                <i class="fa-solid fa-plus"></i>

                <span> Agregar certificado </span>
              </button>
            </div>

            <!-- TABLA -->

            <div class="table-modern-wrapper">
              <div class="table-responsive">
                <table class="table table-modern align-middle mb-0">
                  <caption class="visually-hidden">
                    Tablas Scratchcard
                  </caption>

                  <thead>
                    <tr>
                      <th scope="col">Scratchcard / Usuario</th>

                      <th scope="col">Nombre certificado</th>

                      <th scope="col">Tipo certificado</th>

                      <th scope="col">Vigencia desde</th>

                      <th scope="col">Vigencia hasta</th>

                      <th scope="col">Fecha adición</th>

                      <th scope="col" class="text-center" data-tour="perfil-groups-column">
                        Grupos
                      </th>

                      <th scope="col" class="text-center">Eliminar</th>
                    </tr>
                  </thead>

                  <tbody>
                    <!-- SIN DATOS -->

                    <tr *ngIf="certificados && certificados.length == 0">
                      <td colspan="8">
                        <div class="empty-state">
                          <div class="empty-state-icon">
                            <i class="fa-solid fa-certificate"></i>
                          </div>

                          <strong> No tienes certificados </strong>

                          <span>
                            No se encontraron certificados asociados a tu
                            usuario.
                          </span>
                        </div>
                      </td>
                    </tr>

                    <!-- DATOS -->

                    <tr *ngFor="let certificado of certificados; index as i" class="row-clikeable">
                      <!-- SCRATCHCARD -->

                      <td>
                        <div class="certificate-id">
                          <span class="certificate-scratch">
                            {{ certificado.scratchcard }}
                          </span>

                          <span *ngIf="certificado?.statusCertificadoUanataca" class="certificate-status" [ngClass]="
                              certificado?.statusCertificadoUanataca ===
                              'ISSUED'
                                ? 'status-new'
                                : 'status-renewed'
                            ">
                            {{
                            certificado?.statusCertificadoUanataca ===
                            "ISSUED"
                            ? "Nuevo"
                            : "Renovado"
                            }}
                          </span>
                        </div>
                      </td>

                      <td>
                        {{ certificado.nombre }}
                      </td>

                      <td>
                        {{ certificado?.tipoCertificado?.nombre }}
                      </td>

                      <td>
                        {{
                        toDateTimeLocalTable(certificado?.fechaVigenciaDesde)
                        }}
                      </td>

                      <td>
                        {{ toDateTimeLocalTable(certificado?.fechaVigencia) }}
                      </td>

                      <td>
                        {{ certificado.createdAt | date: "dd/MM/yyyy" }}
                      </td>

                      <!-- GRUPOS -->

                      <td class="text-center">
                        <button type="button" class="action-btn action-groups" data-tour="perfil-certificado-grupos"
                          title="Administrar grupos" (click)="
                            openModalCertificado(
                              certificado,
                              contentGruposModal
                            )
                          ">
                          <i class="fa-solid fa-users"></i>
                        </button>
                      </td>

                      <!-- ELIMINAR -->

                      <td class="text-center">
                        <button type="button" class="action-btn action-delete" title="Eliminar certificado"
                          (click)="removeCertificado(certificado?.id)">
                          <i class="fa-solid fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ng-template>
      </ngb-panel>

      <!-- ================================================== -->
      <!-- CAMBIAR CONTRASEÑA -->
      <!-- ================================================== -->

      <ngb-panel id="password" *ngIf="!isLdap">
        <ng-template ngbPanelTitle>
          <div class="accordion-title" data-tour="perfil-password-title">
            <div class="accordion-icon">
              <i class="fa-solid fa-key"></i>
            </div>

            <div class="accordion-title-info">
              <span class="accordion-title-text"> Cambiar contraseña </span>

              <span class="accordion-title-description">
                Actualiza la contraseña de tu cuenta.
              </span>
            </div>
          </div>
        </ng-template>

        <ng-template ngbPanelContent>
          <div class="section-content password-section" data-tour="perfil-password-content">
            <app-form-change-password [userId]="userId" [userName]="userName">
            </app-form-change-password>
          </div>
        </ng-template>
      </ngb-panel>

      <!-- ================================================== -->
      <!-- SELLO DIGITAL -->
      <!-- ================================================== -->

      <ngb-panel id="mi_sello">
        <ng-template ngbPanelTitle>
          <div class="accordion-title" data-tour="mi-sello-digital">
            <div class="accordion-icon">
              <i class="fa-solid fa-image"></i>
            </div>

            <div class="accordion-title-info">
              <span class="accordion-title-text"> Mi sello digital </span>

              <span class="accordion-title-description">
                Personaliza la imagen utilizada durante la firma.
              </span>
            </div>
          </div>
        </ng-template>

        <ng-template ngbPanelContent>
          <div class="section-content">
            <!-- CONFIGURACIÓN -->

            <div class="signature-option" *ngIf="existeImagen">
              <div class="signature-option-info">
                <div class="signature-option-icon">
                  <i class="fa-solid fa-signature"></i>
                </div>

                <div>
                  <strong> Firmar siempre con imagen </strong>

                  <span>
                    Utiliza automáticamente tu sello digital durante la firma.
                  </span>
                </div>
              </div>

              <label class="modern-switch">
                <input  type="checkbox" id="firmaCustom" [(ngModel)]="firmaConImagen"
                  (change)="onFirmaCustomChange()" />
                  <span class="slider"></span>
              </label>
            </div>

            <!-- PREVIEW -->

            <div class="signature-preview">
              <div class="signature-preview-header">
                <div>
                  <h6>Vista previa</h6>

                  <p>Imagen utilizada como sello digital.</p>
                </div>
              </div>

              <div class="signature-image-container" [style]="
                  scaled ? getStyleContenedorImg(scaled) : 'text-align: center;'
                ">
                <img [src]="imagenUrl" alt="Sello digital" [style]="scaled ? getStyleString(scaled) : null"
                  *ngIf="existeImagen" />

                <div class="signature-empty" *ngIf="!existeImagen">
                  <img [src]="imagenUrl" alt="Sello digital" class="signature-default-image" />
                </div>
              </div>

              <div class="signature-dimensions" *ngIf="existeImagen && scaled">
                <i class="fa-solid fa-ruler-combined"></i>

                <span>
                  {{ scaled.width }} × {{ scaled.height }} — escala
                  {{ scaled.scale }}%
                </span>
              </div>
            </div>

            <!-- UPLOAD -->

            <div class="upload-section">
              <div class="upload-section-header">
                <h6>Imagen del sello</h6>

                <p>
                  Selecciona una imagen PNG para utilizarla como sello digital.
                </p>
              </div>

              <app-file-upload #fileUpload (fileSelected)="handleFiles($event)" [multiple]="false" [extension]="['png']"
                [maxFiles]="1">
              </app-file-upload>
            </div>

            <!-- CONFIGURACIÓN DE TAMAÑO -->

            <form [formGroup]="formSignatureSize" class="signature-form" *ngIf="firmaCustom">
              <div class="form-section-title">
                <i class="fa-solid fa-sliders"></i>

                <span> Configuración de firma </span>
              </div>

              <div class="row g-3">
                <!-- NOMBRE -->

                <div class="col-12 col-md-6">
                  <label class="form-label"> Nombre </label>

                  <input type="text" class="form-control" placeholder="Ej: Firma estándar documento A4"
                    formControlName="nombre" />

                  <app-error-message [control]="formSignatureSize.get('nombre')" errorKey="required"
                    message="La firma personalizada necesita un nombre.">
                  </app-error-message>
                </div>

                <!-- NOMBRE CORTO -->

                <div class="col-12 col-md-6">
                  <label class="form-label"> Nombre corto </label>

                  <input type="text" class="form-control" placeholder="Ej: estandarA4" formControlName="nombre_corto"
                    readonly="true" />
                </div>

                <!-- ANCHO -->

                <div class="col-12 col-md-6">
                  <label class="form-label"> Ancho </label>

                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="Ej: 150" formControlName="width"
                      readonly="true" />

                    <span class="input-group-text"> px </span>
                  </div>
                </div>

                <!-- ALTO -->

                <div class="col-12 col-md-6">
                  <label class="form-label"> Alto </label>

                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="Ej: 80" formControlName="height"
                      readonly="true" />

                    <span class="input-group-text"> px </span>
                  </div>
                </div>
              </div>
            </form>

            <!-- SUBIR -->

            <div class="section-actions">
              <button type="button" class="btn btn-primary btn-modern" (click)="subirImagen(fileUpload)">
                <i class="fa-solid fa-cloud-arrow-up"></i>

                <span> Subir imagen </span>
              </button>
            </div>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>

<!-- ======================================================== -->
<!-- MODAL CREAR CERTIFICADO -->
<!-- ======================================================== -->
<ng-template #content let-modal>
  <div class="certificate-modal">
    <!-- HEADER -->
    <div class="modal-header certificate-modal-header">
      <div class="certificate-modal-title">
        <div class="certificate-modal-icon">
          <i class="fa-solid fa-certificate"></i>
        </div>

        <div>
          <h5>Agregar certificado</h5>
          <p>Asocia un certificado a tu usuario.</p>
        </div>
      </div>

      <button type="button" class="btn-close" aria-label="Cerrar" (click)="modal.dismiss('Cross click')"></button>
    </div>

    <!-- BODY -->
    <div class="modal-body certificate-modal-body" data-tour="modal-certificado-root">
      <form [formGroup]="formCertificate">
        <!-- ========================================= -->
        <!-- BUSCADOR -->
        <!-- ========================================= -->

        <div class="certificate-search" data-tour="modal-certificado-scratchcard">
          <label for="scratchcard" class="form-label">
            Scratchcard / Usuario
          </label>

          <div class="certificate-search-row">
            <div class="certificate-input-icon">
              <i class="fa-solid fa-id-card"></i>

              <input type="text" id="scratchcard" class="form-control" placeholder="Ingresa el Scratchcard o usuario"
                formControlName="scratchcard" data-tour="cert-scratch-input" />
            </div>

            <button type="button" class="btn btn-primary certificate-search-btn" data-tour="cert-scratch-search"
              (click)="searchScratchcard()">
              <i class="fa-solid fa-magnifying-glass"></i>

              <span>Buscar</span>
            </button>
          </div>
        </div>

        <!-- ========================================= -->
        <!-- DATOS -->
        <!-- ========================================= -->

        <div *ngIf="certificateFound || allowManualCertificate" class="certificate-data" data-tour="cert-fields">
          <!-- DIVISOR -->

          <div class="certificate-divider">
            <span> Información del certificado </span>
          </div>

          <div class="row g-3">
            <!-- NOMBRE -->

            <div class="col-12 col-md-6" data-tour="modal-certificado-nombre">
              <label for="nombreCertificado" class="form-label">
                Nombre certificado
                <span class="required">*</span>
              </label>

              <input type="text" id="nombreCertificado" class="form-control" placeholder="Ej: Certificado de firma"
                formControlName="nombre" />

              <span class="field-error" *ngIf="
                  formCertificate.get('nombre')?.touched &&
                  formCertificate.get('nombre')?.errors?.['required']
                ">
                <i class="fa-solid fa-circle-exclamation"></i>

                El nombre del certificado es requerido.
              </span>
            </div>

            <!-- TIPO -->

            <div class="col-12 col-md-6" data-tour="modal-certificado-tipo">
              <label for="tipo_certificado_id" class="form-label">
                Tipo certificado
                <span class="required">*</span>
              </label>

              <select id="tipo_certificado_id" class="form-select" formControlName="tipo_certificado_id">
                <option value="">Seleccione</option>

                <option *ngFor="let tipoCeritificado of tiposCeritificados" [value]="tipoCeritificado?.id">
                  {{ tipoCeritificado?.nombre }}
                </option>
              </select>

              <span class="field-error" *ngIf="
                  formCertificate.get('tipo_certificado_id')?.touched &&
                  formCertificate.get('tipo_certificado_id')?.errors?.[
                    'required'
                  ]
                ">
                <i class="fa-solid fa-circle-exclamation"></i>

                El tipo de certificado es requerido.
              </span>
            </div>

            <!-- ESTADO -->

            <div class="col-12 col-md-6">
              <label class="form-label">
                Estado certificado
                <span class="required">*</span>
              </label>

              <select class="form-select" formControlName="status_certificado_uanataca">
                <option value="">Seleccione</option>

                <option value="ISSUED">Nuevo</option>

                <option value="RENEWED">Renovado</option>
              </select>

              <span class="field-error" *ngIf="
                  formCertificate.get('status_certificado_uanataca')?.touched &&
                  formCertificate.get('status_certificado_uanataca')?.errors?.[
                    'required'
                  ]
                ">
                <i class="fa-solid fa-circle-exclamation"></i>

                El estado del certificado es requerido.
              </span>
            </div>

            <!-- IDENTIFICADOR -->

            <div class="col-12 col-md-6">
              <label class="form-label">
                Identificador
                <span class="required">*</span>
              </label>

              <select class="form-select" formControlName="id_uanataca_identificador">
                <option value="">Seleccione</option>

                <option *ngFor="let identificador of identificadores" [value]="identificador.id">
                  {{ identificador.nombre }}
                </option>
              </select>

              <span class="field-error" *ngIf="
                  formCertificate.get('id_uanataca_identificador')?.touched &&
                  formCertificate.get('id_uanataca_identificador')?.errors?.[
                    'required'
                  ]
                ">
                <i class="fa-solid fa-circle-exclamation"></i>

                El identificador es requerido.
              </span>
            </div>

            <!-- FECHA INICIO -->

            <div class="col-12 col-md-6" data-tour="modal-certificado-vigencia-desde">
              <label class="form-label">
                Fecha inicio vigencia
                <span class="required">*</span>
              </label>

              <input id="fecha_vigencia_desde" type="date" class="form-control"
                formControlName="fecha_vigencia_desde" />

              <span class="field-error" *ngIf="
                  formCertificate.get('fecha_vigencia_desde')?.touched &&
                  formCertificate.get('fecha_vigencia_desde')?.errors?.[
                    'required'
                  ]
                ">
                <i class="fa-solid fa-circle-exclamation"></i>

                La fecha inicio de vigencia es requerida.
              </span>
            </div>

            <!-- FECHA FIN -->

            <div class="col-12 col-md-6" data-tour="modal-certificado-vigencia-hasta">
              <label class="form-label">
                Fecha fin vigencia
                <span class="required">*</span>
              </label>

              <input type="date" class="form-control" formControlName="fecha_vigencia_hasta" />

              <span class="field-error" *ngIf="
                  formCertificate.get('fecha_vigencia_hasta')?.touched &&
                  formCertificate.get('fecha_vigencia_hasta')?.errors?.[
                    'required'
                  ]
                ">
                <i class="fa-solid fa-circle-exclamation"></i>

                La fecha fin de vigencia es requerida.
              </span>

              <div class="col-12" *ngIf="formCertificate.errors?.['fechaVigenciaInvalida']">
                <span class="field-error">
                  <i class="fa-solid fa-circle-exclamation"></i>

                  La fecha de inicio no puede ser posterior a la fecha de
                  finalización.
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- FOOTER -->

    <div class="modal-footer certificate-modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.close('Cerrar click')">
        Cancelar
      </button>

      <button *ngIf="certificateFound || allowManualCertificate" type="button" class="btn btn-primary"
        [disabled]="formCertificateIsSubmited || formCertificate.invalid" data-tour="cert-save-btn"
        (click)="saveCertificate()">
        <i *ngIf="!formCertificateIsSubmited" class="fa-solid fa-floppy-disk me-2">
        </i>

        <span *ngIf="formCertificateIsSubmited" class="spinner-border spinner-border-sm me-2">
        </span>

        Guardar certificado
      </button>
    </div>
  </div>
</ng-template>

<!-- ==========================================================================
     MODAL - ASIGNAR GRUPOS
     ========================================================================== -->

<ng-template #contentGruposModal let-modal>
  <div class="groups-modal">
    <!-- ======================================================================
         01. HEADER
         ====================================================================== -->

    <div class="groups-modal-header">
      <div class="groups-modal-header-content">
        <div class="groups-modal-header-icon">
          <i class="fa-solid fa-users"></i>
        </div>

        <div class="groups-modal-header-text">
          <h5>Asignar grupos</h5>

          <p>Administra los grupos asociados al certificado.</p>
        </div>
      </div>

      <!-- CERRAR X -->

      <button type="button" class="groups-modal-close" aria-label="Cerrar" (click)="modal.dismiss('Cross click')">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- ======================================================================
         02. BODY
         ====================================================================== -->

    <div class="groups-modal-body">
      <!-- ====================================================================
           ASIGNAR NUEVO GRUPO
           ==================================================================== -->

      <div class="groups-assignment-section">
        <!-- HEADER DE SECCIÓN -->

        <div class="groups-section-header">
          <div class="groups-section-header-icon">
            <i class="fa-solid fa-user-group"></i>
          </div>

          <div class="groups-section-header-text">
            <h6>Asignar nuevo grupo</h6>

            <p>Selecciona un grupo o subgrupo para asociarlo al certificado.</p>
          </div>
        </div>

        <!-- ================================================================
             SELECTOR
             ================================================================ -->

        <div class="groups-selector-container" data-tour="modal-grupos-selector">
          <label class="groups-field-label"> Grupo / Subgrupo </label>

          <div class="groups-selector-row">
            <!-- ============================================================
                 COMPONENTE DE GRUPOS
                 ============================================================ -->

            <div class="groups-tree-wrapper" data-tour="modal-grupos-tree">
              <div class="groups-tree-icon">
                <i class="fa-solid fa-layer-group"></i>
              </div>

              <app-groups [tipoGrupo]="tipoGrupo" class="groups-tree-component" (idGroup)="groupChange($event)">
              </app-groups>
            </div>

            <!-- ============================================================
                 BOTÓN ASIGNAR
                 ============================================================ -->

            <button type="button" class="groups-assign-btn" data-tour="modal-grupos-asignar"
              (click)="asignarUsuarioGrupo()">
              <i class="fa-solid fa-plus"></i>

              <span> Asignar </span>
            </button>
          </div>

          <!-- AYUDA -->

          <span class="groups-field-help">
            Selecciona un grupo de la lista y presiona “Asignar”.
          </span>
        </div>
      </div>

      <!-- ====================================================================
           GRUPOS ASIGNADOS
           ==================================================================== -->

      <div class="assigned-groups-section">
        <!-- HEADER -->

        <div class="assigned-groups-header">
          <div>
            <h6>Grupos asignados</h6>

            <p>Grupos y subgrupos asociados actualmente al certificado.</p>
          </div>

          <!-- CONTADOR -->

          <div class="groups-counter" *ngIf="gruposUsuario?.length">
            <i class="fa-solid fa-users"></i>

            <span>
              {{ gruposUsuario.length }}
            </span>
          </div>
        </div>

        <!-- ================================================================
             LISTADO
             ================================================================ -->

        <div class="assigned-groups-list" data-tour="modal-grupos-tabla">
          <!-- ==============================================================
               ESTADO VACÍO
               ============================================================== -->

          <div class="groups-empty-state" *ngIf="gruposUsuario?.length === 0" data-tour="modal-grupos-empty">
            <div class="groups-empty-icon">
              <i class="fa-solid fa-users"></i>
            </div>

            <h6>Sin grupos asignados</h6>

            <p>Este certificado todavía no tiene grupos asociados.</p>
          </div>

          <!-- ==============================================================
               GRUPOS ASIGNADOS
               ============================================================== -->

          <div class="assigned-group-item" *ngFor="let grupoUsuario of gruposUsuario; index as i">
            <!-- INFORMACIÓN -->

            <div class="assigned-group-info">
              <div class="assigned-group-icon">
                <i class="fa-solid fa-user-group"></i>
              </div>

              <div class="assigned-group-text">
                <span class="assigned-group-name">
                  {{ grupoUsuario?.grupo?.nombre }}
                </span>

                <span class="assigned-group-description">
                  Grupo asociado al certificado
                </span>
              </div>
            </div>

            <!-- ELIMINAR -->

            <button type="button" class="assigned-group-delete" data-tour="modal-grupos-remove"
              title="Eliminar asignación" aria-label="Eliminar grupo" (click)="removeAsignacionGrupo(grupoUsuario.id)">
              <i class="fa-solid fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ======================================================================
         03. FOOTER
         ====================================================================== -->

    <div class="groups-modal-footer">
      <span class="groups-modal-footer-info">
        <i class="fa-solid fa-circle-info"></i>

        Los cambios se aplican inmediatamente.
      </span>

      <button type="button" class="groups-close-btn" (click)="modal.close('Cerrar click')">
        Cerrar
      </button>
    </div>
  </div>
</ng-template>